import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    class: "w-100",
    id: _ctx.id,
    size: _ctx.size,
    clearable: _ctx.clearable,
    placeholder: _ctx.placeholder,
    modelValue: _ctx.inputModelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputModelValue) = $event))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item['value'],
          value: item['value'],
          label: item['label']
        }, null, 8, ["value", "label"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["id", "size", "clearable", "placeholder", "modelValue"]))
}